import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { ListItem } from "../../../../shared/list/list-item";
import { MemberCentricChase } from "../../../../shared/membercentric-doc-attachment/membercentric-chase.model";
import { obsolete } from "../../../../utilities/decorators/obsolete.decorator";
import { ChartFilters } from "../chase-detail-v2/chart-filters.model";
import { ChaseDetail } from "./chase-detail.model";

@Injectable()
export class ChaseDetailService {
  chaseDetailsChange = new BehaviorSubject<ListItem[]>([]);
  chaseDetailsChangeObserver: Observable<any> = this.chaseDetailsChange.asObservable();

  ocrDataAvailableChange = new BehaviorSubject<boolean>(false);


  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }


  @obsolete("getChaseDetail") getSummaryItems(chaseId: number): Observable<ListItem[]> {
    const url = `${this.baseApiUrl}Chase?chaseId=${chaseId}`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default", "ListItem"))
    );
  }

  getChaseDetail(chaseId: number): Observable<ChaseDetail> {
    const url = `${this.baseApiUrl}chase/detail?chaseId=${chaseId}`;
    return this.http.get(url).pipe(
      map(this.automapper.curry("default", "ChaseDetail"))
    );
  }

  getChaseOCRDetails(chaseId: number): Observable<boolean> {
    const url = `${this.baseApiUrl}chase/ocrdataavailable?chaseId=${chaseId}`;
    return this.http.get(url).pipe(
      map((response: any) => response as boolean)
    );
  }

  getMemberCentricChasesForAssignment(chaseIds: number[], assignedToUserId: number): Observable<MemberCentricChase[]> {
    const url = `${this.baseApiUrl}member/memberchasesforassignment?assignedToUserId=${assignedToUserId}`;

    return this.http.post(url, chaseIds).pipe(
      map(this.automapper.curryMany("default", "MemberCentricChase"))) as Observable<MemberCentricChase[]>;
  }

  getChaseFilters(chaseId: number): Observable<ChartFilters> {
    const url = `${this.baseApiUrl}chase/risk/filter/metadata?chaseId=${chaseId}`;
    return this.http.get(url).pipe(map((response: any) => response as ChartFilters));
  }
}
